import { ScrollHelper } from "helpers/scroll-helper";
import { autoinject, bindable } from "aurelia-framework";

@autoinject
export class CollapseAll {
  public wrapper: any = null;

  @bindable
  public isSticky: boolean = false;

  constructor(private readonly scrollHelper: ScrollHelper) { }

  public bind(): void {
    if (this.isSticky) {
      this.scrollHelper.fixTop(this.wrapper);
    }
  }

  public collapseAll(): void {
    this.collapseLogic(true,  ".drawer.open");
  }

  public expandAll(): void {
    this.collapseLogic(false, ".drawer:not(open)");
  }

  private collapseLogic(collapse: boolean, selector: string): void {
    const drawers = document.querySelectorAll(selector);

    for (let i = 0; !!drawers[i]; i++) {
        const drawer = drawers[i];

        if (collapse) {
          drawer.classList.remove("open");
        } else {
          drawer.classList.add("open");
        }
    }
  }
}
